export * from './cadastro-state.interface';
export * from './imovel-state.interface';
export * from './pagamento-state.interface';
export * from './proprietario-state.interface';
